import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GoDialogOutletModule } from '@gomaterials/ui-components/dialogoutlet';
import { GoToastModule } from '@gomaterials/ui-components/toast';

import { APP_DIALOG_KEY } from '@core/constants';

@Component({
    selector: 'app-auth-page-layout',
    imports: [RouterModule, GoDialogOutletModule, GoDialogOutletModule, GoToastModule],
    template: `
        <main>
            <ng-content></ng-content>
        </main>

        <go-dialog-outlet [key]="appDialogKey" data-test-id="app-dialog"></go-dialog-outlet>
        <go-toast styleClass="app-toast" data-test-id="app-toast"></go-toast>
    `,
})
export class AuthPageLayoutComponent {
    appDialogKey = APP_DIALOG_KEY;
}
